import { render, staticRenderFns } from "./SpaceMediumOne.vue?vue&type=template&id=857691d6&"
import script from "./SpaceMediumOne.vue?vue&type=script&lang=js&"
export * from "./SpaceMediumOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports